import { render } from "./TutorAvailability.vue?vue&type=template&id=c95fdf08"
import script from "./TutorAvailability.vue?vue&type=script&lang=js"
export * from "./TutorAvailability.vue?vue&type=script&lang=js"

import "./TutorAvailability.vue?vue&type=style&index=0&id=c95fdf08&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__